import React from 'react';
import './header.scss';
import moneyFormatter from 'money-formatter';

const Header = ({ loanAmount, loanApr, months, monthlyAmount }) => {
  return (
    <div className="combo-app-header">
      <div className="row bcus-dark-cyan text-white px-4 py-3 text-center">
        <div className="col-12 p-2 mb-2 loan-details-title">YOUR LOAN DETAILS</div>
        <div className="col-6 col-md-3">
          <h4 className="px-1">{moneyFormatter.format('USD', loanAmount, 0)}</h4>
          <p>Requested amount</p>
        </div>
        <div className="col-6 col-md-3">
          <h4 className="">{moneyFormatter.format('USD', monthlyAmount, 0)}</h4>
          <p>Monthly payment</p>
        </div>
        <div className="col-6 col-md-3">
          <h4 className="px-1">{months} months</h4>
          <p>Loan term</p>
        </div>
        <div className="col-6 col-md-3">
          <h4 className="px-1">{loanApr}%</h4>
          <p>APR</p>
        </div>
      </div>
    </div>);
};

export default Header;
